<div id="wrapper">
	<div class="topbar">
		<div class="navbar navbar-default" role="navigation">
			<div class="container" style="text-align: center">
				<a href="/" class="js-home-button">
					<img class="menubar-logo-s h-home-logo-xs" src="/style/logo/2" />
				</a>
				<div class="exposed-background pull-left">
					<span id="main-menu-toggle" class="open-left visible-xs-inline">
						<i class="md md-menu"></i>
					</span>
					<a href="/" class="js-home-button">
						<img class="menubar-logo-x h-home-logo" src="/style/logo/0" />
					</a>
				</div>
				<div class="pull-right">
					<ul id="menu" class="p-l-0 m-b-0"></ul>
				</div>
			</div>
		</div>
		<div id="mobile-search-bar" class="collapse hidden-md hidden-lg">
			<form role="search" class="app-search device-search menubar-search menubar-search-padding">
				<input type="text" id="js-mobile-device-search-term" placeholder="{{TR "Suche..."}}" class="form-control menubar-search-color full-width">
				<a href="" id="js-mobile-device-search" class="menubar-search-padding menubar-search-color"><i class="fa fa-search"></i></a>
				<a id="js-close-search-bar" data-target="#mobile-search-bar" data-toggle="collapse">
    				<i class="fa fa-times"></i>
				</a>
			</form>
		</div>
	</div>
	<div class="left side-menu">
		<div id="sidebar" class="sidebar-inner slimscrollleft"></div>
		<div class="clearfix"></div>
		<div id="sidebar-menu-toggle" class="open-left hidden-xs enlarged">
			<i class="fa fa-angle-left"></i>
		</div>
	</div>
	<div class="content-page">
		<div class="content">
			<div class="container">
				<div id="breadcrumbs"></div>
				<div id="content"></div>
			</div>
		</div>
		<footer class="footer footer-custom">
			<div class="hidden-md hidden-lg">
				<center>
					<a href="#imprint">{{TR "Impressum"}}</a> |
					<a href="#terms">{{TR "Nutzungsbedingungen"}}</a> |
					<a href="#data_protection">{{TR "Datenschutzhinweis"}}</a> |
					<a href="https://www.samson.de/document/e69010de.pdf">{{TR "Handbuch"}}</a> |
					<a href="#" class="js-send-feedback">{{TR "Feedback"}}</a> |
					<a href="mailto:information-security-de@samsongroup.com?subject={{TR "Informationssicherheit"}}">{{TR "Informationssicherheit"}}</a> |
					<a href="#" class="js-switch-v2"><strong>{{TR "Neue Ansicht"}}</strong></a>
					<span id="js-help"> | <a><i class="fa  fa-question-circle"></i></a></span>
					{{#if showOSLicenceLink}}
					| <a href="opensource.txt" target="_blank">{{TR "OpenSource Lizenzen"}}</a>
					{{/if}}
					<br />
					{{{COPYRIGHT}}}
				</center>
			</div>
			<div class="visible-md visible-lg">
				<div class="pull-right">{{{COPYRIGHT}}}</div>
				<div class="pull-left">
					<a href="#imprint">{{TR "Impressum"}}</a> |
					<a href="#terms">{{TR "Nutzungsbedingungen"}}</a> |
					<a href="#data_protection">{{TR "Datenschutzhinweis"}}</a> |
					<a href="https://www.samson.de/document/e69010de.pdf">{{TR "Handbuch"}}</a> |
					<a href="#" class="js-send-feedback">{{TR "Feedback"}}</a> |
					<a href="mailto:information-security-de@samsongroup.com?subject={{TR "Informationssicherheit"}}">{{TR "Informationssicherheit"}}</a> |
					<a href="#" class="js-switch-v2"><strong>{{TR "Neue Ansicht"}}</strong></a>
					<span id="js-help"> | <a><i class="fa  fa-question-circle"></i></a></span>
					{{#if showOSLicenceLink}}
					| <a href="opensource.txt" target="_blank">{{TR "OpenSource Lizenzen"}}</a>
					{{/if}}
				</div>
			</div>
		</footer>
	</div>
</div>
